import { createRouter, createWebHistory } from 'vue-router';

import iimmpact from '@/module/Iimmpact/page/Iimmpact.vue'
import IimmpactHistory from '@/module/Iimmpact/page/IimmpactHistory.vue';
import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

import Announcement from '@/module/Announcement/page/Announcement.vue';


const routes = [
    {
        path: '/',
        name: 'default',
        component: Default
    },
    {
        path: '/iimmpact',
        name: 'iimmpact',
        component: iimmpact
    },
    {
        path: '/iimmpact/history',
        name: 'iimmpact_history',
        component: IimmpactHistory
    },
    {
        path: '/announcement',
        name: 'announcement',
        component: Announcement,
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
